/**
 * One money string, wherever a page has to print an
 * amount the server did not render.
 *
 * Mirrors `number_to_currency`: the unit, the group mark
 * and the decimal mark are all SUPPLIED, never guessed,
 * because they come from Rails' own `number.format` for
 * the request's locale. Hardcoding en-US here renders
 * "1,234.56" beside server amounts printed "1.234,56" on
 * every EUR/BRL/COP/ARS/CLP/CRC venue: same page, two
 * conventions.
 *
 * Extracted from `tip-selector`, which owned it
 * privately until the admin order builder needed the
 * same peso to look the same on a second surface. A
 * private formatter is fine right up until there are two
 * of them, and then the choice is a shared module or two
 * subtly different renderings of one amount.
 *
 * THE SIGN GOES AFTER THE UNIT, `$-50.00` and not
 * `-$50.00`, because that is what `Money#format`
 * produces and every discount row in the product is
 * rendered by it. The builder writes a discount into a
 * node the server also renders, so a merchant would
 * otherwise read `$-50.00` on load and `-$50.00` after a
 * tap: one amount, two formats, depending on which side
 * touched the DOM last. Changing the SERVER to match
 * this instead would restyle every discount row on every
 * surface, which is an open decision and not this
 * ticket's.
 *
 * Nothing on the customer checkout formats a negative
 * (a total, a tip and a fee are all non-negative), so
 * this branch is the builder's alone.
 */
export function moneyString(
  cents,
  {symbol = "$", delimiter = ",", separator = "."} = {}
) {
  const abs = Math.abs(cents);
  const units = String(Math.floor(abs / 100));
  const fraction = String(abs % 100).padStart(2, "0");
  const grouped = units.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    delimiter
  );
  const sign = cents < 0 ? "-" : "";

  return (
    `${symbol}${sign}${grouped}${separator}${fraction}`
  );
}
